module.exports = __webpack_public_path__ + "static/media/confused-emoji-svgrepo-com.745e92d4.svg";